/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Book_ChipInputs */

const en_how_page_book_chip = /** @type {(inputs: How_Page_Book_ChipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay in the app`)
};

const pl_how_page_book_chip = /** @type {(inputs: How_Page_Book_ChipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatność w aplikacji`)
};

/**
* | output |
* | --- |
* | "Pay in the app" |
*
* @param {How_Page_Book_ChipInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_book_chip = /** @type {((inputs?: How_Page_Book_ChipInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Book_ChipInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_book_chip(inputs)
	return en_how_page_book_chip(inputs)
});